import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/LegalPage";
import { buildSeoMeta } from "@/lib/seo";

export const Route = createFileRoute("/polityka-prywatnosci")({
  head: () =>
    buildSeoMeta({
      title: "Polityka prywatności | SyncTech",
      description: "Polityka prywatności SyncTech — zasady przetwarzania danych osobowych zgodne z RODO.",
      path: "/polityka-prywatnosci",
      noindex: false,
    }),
  component: PrivacyPolicy,
});

function PrivacyPolicy() {
  return (
    <LegalPage title="Polityka prywatności" lastUpdated="6 maja 2026">
      <h2>1. Administrator danych</h2>
      <p>
        Administratorem Twoich danych osobowych jest <strong>Piotr Ziółkowski</strong>{" "}
        prowadzący działalność nierejestrowaną pod marką <strong>SyncTech</strong>, z siedzibą
        w <strong>Warszawie (woj. mazowieckie)</strong>. Kontakt:{" "}
        <strong>kontakt@synctech.pl</strong>.
      </p>
      <p className="text-sm text-muted-foreground">
        Administrator korzysta ze zwolnienia podmiotowego z VAT (art. 113 ust. 1 i 9 ustawy o VAT) i rozlicza się ryczałtem ewidencjonowanym 12%.
      </p>

      <h2>2. Zakres danych</h2>
      <p>Przetwarzamy następujące dane osobowe:</p>
      <ul>
        <li>imię i nazwisko (formularz kontaktowy);</li>
        <li>adres e-mail (formularz kontaktowy, newsletter, lead magnet);</li>
        <li>treść wiadomości (formularz kontaktowy);</li>
        <li>dane techniczne (adres IP, typ przeglądarki, system operacyjny) — w zakresie analityki ruchu.</li>
      </ul>

      <h2>3. Cele i podstawa prawna</h2>
      <ul>
        <li>obsługa zapytań przez formularz kontaktowy — art. 6 ust. 1 lit. b RODO;</li>
        <li>wysyłka materiałów (lead magnet, newsletter) — art. 6 ust. 1 lit. a RODO (zgoda);</li>
        <li>analityka ruchu (Google Analytics 4) — art. 6 ust. 1 lit. f RODO (uzasadniony interes).</li>
      </ul>

      <h2>4. Czas przechowywania</h2>
      <p>
        Dane przechowujemy przez okres niezbędny do realizacji celu — zwykle do 24 miesięcy od ostatniego kontaktu,
        a w przypadku newslettera do momentu wycofania zgody.
      </p>

      <h2>5. Twoje prawa</h2>
      <p>Masz prawo do: dostępu, sprostowania, usunięcia, ograniczenia przetwarzania, przenoszenia, sprzeciwu i wycofania zgody w każdej chwili. Skargę możesz złożyć do Prezesa UODO.</p>

      <h2>6. Pliki cookies</h2>
      <p>
        Serwis używa plików cookies niezbędnych do działania oraz cookies analitycznych/marketingowych — wyłącznie po wyrażeniu zgody w bannerze cookies (Google Consent Mode v2).
      </p>

      <h2>7. Powierzenia danych</h2>
      <p>
        Korzystamy z usług zewnętrznych dostawców: Google (Analytics, Workspace), Lovable / Cloudflare (hosting), Resend (transakcyjne maile), Calendly (rezerwacje) — na podstawie umów powierzenia.
      </p>

      <h2>8. Kontakt</h2>
      <p>
        W sprawach związanych z przetwarzaniem danych: <strong>kontakt@synctech.pl</strong>.
      </p>
    </LegalPage>
  );
}
